import React from "react";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { socialIcons } from "common/StringUtils";

const BusinessContactUs = ({ t, dashboardFooter, validated, handleSubmit }) => {
  return (
    <section className="newdesign business new_busins_desgn contact_fm_new">
      <div className="container p-0">
        <div className="row justify-content-center">
          <div className="col-lg-11 col-md-10 p-0">
            <div className="sectin_new">
              <div className="text-heading text-center mb-3">
                <h2>{t("CONTACT US")}</h2>
              </div>
              <div className="cnt_fm">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-5  p-0">
                    <div className="backgrund_purble">
                      <h3 className="mb-3">{t("Customer Information")}</h3>
                      <h4>
                        {t(
                          "Fill out the contact form, and our team will contact you within 24 hours."
                        )}
                      </h4>
                      <div className="contct_number mt-4">
                        <div className="icn_cnts d-flex align-items-center">
                          <p className="pr_icn mr-3">
                            <BsFillTelephoneFill />
                          </p>
                          <p className="number_fld">{import.meta.env.VITE_SUPPORT_PHONE_NUMBER}</p>
                        </div>
                        <div className="icn_cnts d-flex align-items-center mt-4">
                          <p className="pr_icn mr-3">
                            <MdEmail />
                          </p>
                          <p className="number_fld">business@invozio.com</p>
                        </div>
                      </div>
                      <div className="social-icons nw_footer_desigm mt-5 pt-2">
                        <div className="div_nwe">
                          <div className="para_gras">
                            <span className="bordr_sets">
                              {t("Official Channels")}
                            </span>
                          </div>
                          <div className="icons ml-4">
                            {socialIcons?.links.map((linkItem, index) => (
                              <a
                                className={
                                  dashboardFooter === false
                                    ? "social_media"
                                    : "social_media"
                                  // dashboard_footIcon
                                }
                                key={index}
                                href={linkItem.link}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={linkItem?.ariaLabel}
                              >
                                {linkItem.icon}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7  p-0">
                    <div className="contc_form_desgn">
                      <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                      >
                        <Row className="mb-3">
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <Form.Label>{t("First Name")}</Form.Label>
                            <Form.Control required type="text" />
                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom02"
                          >
                            <Form.Label>{t("Last Name")}</Form.Label>
                            <Form.Control required type="text" />
                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                        <Row className="mb-3">
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom03"
                          >
                            <Form.Label>{t("Email")}</Form.Label>
                            <Form.Control required type="email" />
                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom04"
                          >
                            <Form.Label>{t("Phone")}</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              pattern="[0-9]{10,}"
                              onKeyDown={(e) => {
                                if (
                                  !/[\d.]/.test(e.key) &&
                                  ![
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Tab",
                                    "Delete",
                                  ].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                        <Row className="mb-3 pt-0 mb-3">
                          <Form.Group
                            as={Col}
                            md="12"
                            controlId="validationCustom05"
                          >
                            <Form.Label>{t("Message")}</Form.Label>
                            <Form.Control
                              className="mt-0"
                              as="textarea"
                              placeholder={t("Write your message")}
                              rows={4}
                              required
                            />
                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                        <div className="button-wrapper">
                          <Button
                            type="submit"
                            className="text-light save_add_customer new_theme_btn ml-2"
                          >
                            {t("Send Message")}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessContactUs;